/**
 * Login, MFA, confirmação de identidade e recuperação de senha vivem no
 * myplat-sso-web-vite agora — este app só mantém rotas de registro e a tela de
 * tenant (que tem lógica própria: agrupamento owner/personalização + modal de
 * versão do Maker, que a tela /tenant genérica do SSO não cobre).
 *
 * Qualquer redirecionamento pro login precisa ir pra lá, sempre com `?app=maker`
 * (ver appBaseUrl() em myplat-sso-web-vite/src/pages/auth/authFlow.ts) — sem esse
 * parâmetro o SSO manda de volta pro app principal (myplat-react-web-vite) depois
 * de logar, não pro Maker.
 */

const SSO_APP_URL = process.env.REACT_APP_SSO_APP_URL || 'https://sso.myplat.net.br';

export function ssoLoginUrl(returnPath = '/maker') {
  const params = new URLSearchParams({ app: 'maker', return: returnPath });
  return `${SSO_APP_URL}/login?${params.toString()}`;
}

export function redirectToSsoLogin(returnPath) {
  window.location.href = ssoLoginUrl(returnPath);
}
